import React from 'react'
import { getImgUrl, hbsBoolean, i18n } from '../../../../common/util'
import { AppContext } from '../../../../config/context'

class HmNew extends React.Component {
    constructor() {
        super(...arguments)
        const list = window._inject_app_data_.sale
        const videoResource = list[0] && list[0].exts && list[0].exts[0] ? list[0].exts[0].value : ''
        this.state = {
            list,
            videoResource
        }
    }

    getVideo = p => {
        const videoResource = p.exts && p.exts[0] && p.exts[0].value
        if (videoResource === this.state.videoResource) {
            return
        }
        this.setState({
            videoResource
        })
    }

    render() {
        const { list, videoResource } = this.state
        const { lang } = this.context.user
        return <div className="homemade-new-container">
            <div className="homemade-video-wrapper">
                {
                    hbsBoolean(videoResource) && <video controls muted autoPlay loop src={videoResource} className="homemade-new-video"></video>
                }
            </div>
            <ul>
                {
                    list.map((item, i) => <li className="homemade-new-item" key={item.goodsId} onMouseEnter={() => this.getVideo(item)}>
                        <a target={item.target} href={item.url} st-btn="1" st-category="橱窗" st-label="新品上架"
                            st-action="click" st-value={JSON.stringify([{ goodsId: item.goodsId, goodsName: item.name }])} st-element-id={`homemade-new-${i}`}>
                            <img alt="" className="homemade-new-img" src={getImgUrl(item.imgUrl)}></img>
                            {
                                hbsBoolean(item.discountTxt) && <span className="homemade-new-discount">{item.discountTxt}</span>
                            }
                            <div className="homemade-new-price">
                                {
                                    hbsBoolean(item.primePrice) ? <p className="op">&yen;{item.primePrice}</p> : <div className="op-p"></div>
                                }
                                <p className="price">&yen;{item.salePrice}</p>
                            </div>
                            <div className="homemade-new-info">
                                <p className="name">{i18n(item.name, lang)}</p>
                                <p className="des">{i18n(item.desc, lang)}</p>
                            </div>
                        </a>
                    </li>)
                }
            </ul>
        </div>
    }
}

HmNew.contextType = AppContext
export default HmNew